import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import GenericReturn from 'app/model/generic/generic-return.model';
import { AppVersion } from 'app/model/manage-versions/AppVersion';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AppsService {
  apiURL = environment.API;
  apiURLAlfresco = environment.AlfrescoAPI;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getAppVersionByAppUrl(appUri: string): Observable<GenericReturn<AppVersion[]>> {
    return this.httpClient.get<GenericReturn<AppVersion[]>>(
      this.apiURL + `/version/find-by-app-url?appuri=${appUri}`,
      this.httpOptions
    );
  }

  getNodeContent(nodeId: string): Observable<Blob> {
    const headers = new HttpHeaders()
      .set('Accept', 'application/octet-stream')
      .set('Authorization', sessionStorage.getItem('tokenAuth'))
      // .set('X-Skip-Interceptor', 'true');

    return this.httpClient.get<Blob>(
      this.apiURLAlfresco + `/alfresco/api/-default-/public/alfresco/versions/1/nodes/${nodeId}/content?attachment=false`,
      { headers, responseType: 'blob' as 'json' }
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/apps/apps.service.ts